export default "__VITE_ASSET__43ef042b__"